var map = {
	"./4filtering/calathea-lancifolia.svg": "8896",
	"./4filtering/chamaedorea-elegans.svg": "JiQf",
	"./4filtering/dracaena-trifasciata.svg": "bz9H",
	"./4filtering/zamioculcas-zamiifolia.svg": "dIaE",
	"./calathea-lancifolia.svg": "QyhK",
	"./chamaedorea-elegans.svg": "jT01",
	"./dracaena-trifasciata.svg": "3YOH",
	"./slicecat.svg": "lVPE",
	"./zamioculcas-zamiifolia.svg": "ZLud"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zZ8A";